import React from 'react';
import './index.scss';

const SpinnerComponent = ({ className = '' }) => {
  return (
    <div className={`spinner-component ${className}`}>
      <div className="ring"></div>
    </div>
  );
};

export default SpinnerComponent;
